import React from 'react';
import cx from 'clsx';
import type Link from 'next/link';

import { usePushWithQuery } from '~/hooks/url';
import { openModal } from '~/utils/mobileApp';

export type LinkComponentType = typeof AppMarketHomeLink | typeof Link;

const AppMarketHomeLink = ({
  href,
  children,
  externalBrowser,
  className,
  onClick,
}: {
  href: string;
  children: React.ReactNode;
  externalBrowser?: boolean;
  className?: string;
  onClick?: () => void;
}) => {
  const nextPush = usePushWithQuery();

  return (
    <span
      role="presentation"
      className={cx(className, '!m-0')}
      onClick={() => {
        onClick?.();

        if (href.startsWith('http')) {
          openModal({
            url: href,
            externalBrowser,
          });
          return;
        }

        void nextPush(href, false);
      }}
    >
      {children}
    </span>
  );
};

export default AppMarketHomeLink;
